"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APInlineButton = _interopRequireDefault(require("../common/APInlineButton"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var orderBookClasses = (0, _cssClassesHelper.getBEMClasses)('orderbook');
var SpreadRowComponent = function SpreadRowComponent(_ref) {
  var spread = _ref.spread,
    onCenterClick = _ref.onCenterClick,
    showCenterButton = _ref.showCenterButton;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: orderBookClasses('spread-row')
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('Spread'), " ", spread), onCenterClick && showCenterButton && /*#__PURE__*/_react["default"].createElement(_APInlineButton["default"], {
    icon: "center",
    iconModifier: "small",
    text: t('Center'),
    onClick: onCenterClick,
    customClass: orderBookClasses('center-button')
  }));
};
var _default = exports["default"] = SpreadRowComponent;